
import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/UpdateEan';


const UpdateEan = ({ t }) => (
  <Container>
       
    <Row>
      <HorizontalForm />
    </Row>
   
  </Container>
);
UpdateEan.propTypes = {
  t: PropTypes.func.isRequired,
};
export default withTranslation('common')(UpdateEan);
